<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">公告管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="有效状态">
            <el-select v-model="IsEffective" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in effectiveData"
                :key="item.Extend1"
                :label="item.Description"
                :value="item.Extend1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布状态">
            <el-select v-model="IsPublish" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in publishStatusData"
                :key="item.Extend1"
                :label="item.Description"
                :value="item.Extend1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发布渠道">
            <el-select v-model="PublishChannel" placeholder="请选择">
              <el-option key="" label="全部" value=""></el-option>
              <el-option
                v-for="item in publishChannelData"
                :key="item.Extend1"
                :label="item.Description"
                :value="item.Extend1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公告标题" prop="Title">
            <el-input v-model="Title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="Title" label="标题"></el-table-column>
              <el-table-column
                prop="ModifyTime"
                label="有效期"
                :formatter="formatDate"
                width="280"
              >
                <template slot-scope="scope">
                  {{ scope.row.EffectiveFrom | formatDatSingle }}~{{
                    scope.row.EffectiveTo | formatDatSingle
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="ModifyTime"
                label="修改时间"
                :formatter="formatDate"
                width="200"
              ></el-table-column>
              <el-table-column label="有效状态" width="140">
                <template slot-scope="scope">
                  {{
                    timeComparison(
                      scope.row.EffectiveFrom,
                      scope.row.EffectiveTo
                    )
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="IsPublish" label="发布状态" width="140">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsPublish == '0'">未发布</span>
                  <span v-else-if="scope.row.IsPublish == '1'">已发布</span>
                  <span v-else-if="scope.row.IsPublish == '2'">已下架</span>
                </template>
              </el-table-column>

              <el-table-column  label="操作" width="160">
                <template slot-scope="scope">
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >查看</el-button
                  >
                  <!-- 如果公告未发布，有编辑按钮 -->
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    v-if="scope.row.IsPublish == '0'"
                    >编辑</el-button
                  >
                  <el-button
                    @click="deleteClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >删除</el-button
                  >
                  <!-- 如果公告未发布，有发布按钮 -->
                  <el-button
                    @click="releaseOrno(scope.$index, scope.row, '1')"
                    type="text"
                    size="small"
                    v-if="scope.row.IsPublish == '0'"
                    >发布</el-button
                  >
                  <!-- 如果公告已发布，有下架按钮 -->
                  <el-button
                    @click="releaseOrno(scope.$index, scope.row, '2')"
                    type="text"
                    size="small"
                    v-if="scope.row.IsPublish == '1'"
                    >下架</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import waitAll from "../../../../../../utils/src/waitAll";
export default {
  name: "AnnouncementList",
  controller: "UI",
  action: "AnnouncementList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      effectiveData: [],  //存储所有有效状态的数组
      publishStatusData: [],  //存储所有发布状态的数组
      publishChannelData: [],  //存储所有发布渠道的数组
      selectData: null,  //存储表格中选中的数据
      Title: "",
      PublishChannel: "", //发布渠道
      IsPublish: "", //发布状态
      IsEffective: "", //有效状态
    };
  },
  // 在模板渲染成html前调用：初始化某些属性值，然后再渲染成视图
  created: function() {
    this.basedataEffective();
    this.basedataPublishStatus();
    this.basedataPublishChannel();
  },
  // 在模板渲染成html后调用：初始化页面完成后，再对dom节点进行一些需要的操作
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "公告管理查询";
    this.logInfo.LogMessage = "公告管理查询";
    this.logInfo.ModuleName = "公告管理";
    this.logInfo.PageName = "公告管理列表";
    this.addOperationLog();
  },
  // 过滤器：格式化日期
  filters: {
    formatDatSingle(data) {
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
  },
  methods: {
    releaseOrno(ind, data, status) {
      //发布或者下架
      let that = this;
      // status 1是发布，0是下架
      data.IsPublish = status;
      // 实例化接口对象
      new MyApis.TranResourcesApi()
        //调用接口中的方法，传入data
        .UpdateItem(data)
        // 返回r
        .then((r) => {
          r = r.data.Data;
          // 消息提示
          this.$message({
            type: "success",
            message: r ? "保存成功！" : "保存失败！",
          });
          if (status == "2") {
            this.logInfo.ActionName = "公告下架";
            this.logInfo.LogMessage = "下架成功";
          } else {
            this.logInfo.ActionName = "公告发布";
            this.logInfo.LogMessage = "发布成功";
          }
          this.logInfo.ModuleName = "公告管理";
          this.logInfo.PageName = "公告管理列表";
          this.addOperationLog();
          that.search();
        })
        // 捕获异常
        .catch((e) => {
          console.log(e);
          // 响应的异常信息
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 表格的选中 可以获得当前选中的数据---@selection-change
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    // 查询按钮功能
    search() {
      //  "Title": "",
      // "PublishChannel": "",//发布渠道
      // "IsPublish": "", //发布状态
      // "IsEffective": "",//有效状态
      let searchInfo = {
        InfoType: 1, //1是公告，2是告警
        Title: this.Title,
        PublishChannel: this.PublishChannel, //发布渠道
        IsPublish: this.IsPublish, //发布状态
        IsEffective: this.IsEffective, //有效状态
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      // 实例化接口对象
      new MyApis.TranResourcesApi()
        // 调用接口中的方法：点击查询所展示的内容
        .GetPageContentByConditions(searchInfo)
        .then((r) => {
          r = r.data.Data;
          // 返回的页面内容给表格
          this.tableData = r.PageContents;
          // 查询到的总记录条数给total
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    // 清理按钮功能
    clearsearch() {
      // 置空
      this.Title = "";
      this.PublishChannel = "";
      this.IsPublish = "";
      this.IsEffective = "";
    },
    // 页面初始化时，获取有效状态
    basedataEffective() {
      //有效状态
      this.config
        .getUValue("UnifiedRelease:EffectiveStatus:", "")
        .then((d) => {
          this.effectiveData = d.JValue;
          //  for(var i = 0; i < this.effectiveData.length; i++) {
          //      var item=this.effectiveData[i];
          //      this.TranresourcesTypeDic[item.ItemKey]=item.Extend1;
          // }
        })
        .catch((e) => console.error(e));
    },
    // 初始化页面时调用，获取发布状态
    basedataPublishStatus() {
      //发布状态
      this.config
        .getUValue("UnifiedRelease:PublishStatus:", "")
        .then((d) => {
          this.publishStatusData = d.JValue;
          //  for(var i = 0; i < this.publishStatusData.length; i++) {
          //      var item=this.options[i];
          //      this.TranresourcesTypeDic[item.ItemKey]=item.Extend1;
          // }
        })
        .catch((e) => console.error(e));
    },
    // 初始化页面时调用，获取发布渠道
    basedataPublishChannel() {
      //发布渠道
      this.config
        .getUValue("UnifiedRelease:PublishChannel:", "")
        .then((d) => {
          this.publishChannelData = d.JValue;
          //  for(var i = 0; i < this.publishChannelData.length; i++) {
          //      var item=this.publishChannelData[i];
          //      this.TranresourcesTypeDic[item.ItemKey]=item.Extend1;
          // }
        })
        .catch((e) => console.error(e));
    },
    // 点击查询按钮
    onSearch() {
      // 当前页置第一页
      this.currentPage = 1;
      // 调用查询方法
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    //编辑按钮：针对未发布公告
    editClick(index, row) {
      // 跳转到公告详情页面
      this.$router.push({
        path: "/plugin/unifiedRelease/UI/AnnouncementInfo",
        query: {
          InfoId: row.InfoId,
          type: "edit",
        },
      });
    },
    //点击查看按钮，传入索引和对应的行
    handleClick(index, row) {
      console.log(index);
      console.log(row);
      this.$router.push({
        path: "/plugin/unifiedRelease/UI/AnnouncementInfo",
        // name: 'mallList',
        query: {
          InfoId: row.InfoId,
          type: "look",
        },
      });
    },
    // 添加公告
    onAdd() {
      this.$router.push({
        path: "/plugin/unifiedRelease/UI/AnnouncementInfo",
        query: {
          type: "add",
        },
      });
    },
    //删除按钮：批量删除
    onbatchDel() {
      if (
        // 判断有数据选中
        this.selectData != undefined &&
        this.selectData != null &&
        this.selectData.length > 0
      ) {
        // 弹出确认框
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })  //点击确认后
          .then(() => {
            const selectData = this.selectData;
            const count = selectData.length;
            // console.log("selectData")
            // console.log(selectData)
            var arr = [];
            // 清除 所有勾选项
            this.$refs.multipleTable.clearSelection();
            if (count > 0) {
              selectData.forEach((item) => {
                new MyApis.TranResourcesApi()
                  .DelItem(item)
                  .then((r) => {
                    r = r.data.Data;
                    arr.push(r);
                  })
                  .catch((e) => {
                    console.log(e);
                  });
              });
              waitAll(arr)
                .then((r) => {
                  // resolve(r);
                  if (r) {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    this.logInfo.ActionName = "公告删除";
                    this.logInfo.LogMessage = "公告删除成功";
                    this.logInfo.ModuleName = "公告管理";
                    this.logInfo.PageName = "公告管理列表";
                    this.addOperationLog();
                    this.search();
                  }
                })
                .catch((e) => {
                  // reject(e);
                  if (e) {
                    this.$message({
                      type: "error",
                      message: "删除失败!",
                    });
                  }
                });
            }
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！",
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DelItem(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "公告管理删除";
                this.logInfo.LogMessage = "公告管理删除成功";
                this.logInfo.ModuleName = "公告管理";
                this.logInfo.PageName = "公告管理列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    ConvertTranresourcesType(row, column) {
      let data = row[column.property];
      if (data == null) {
        return null;
      }
      let levelstr = this.TranresourcesTypeDic[data];
      return levelstr;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    timeComparison(startDate, endDate) {
      let todayDate = new Date();
      let date1 = new Date(startDate);
      let date2 = new Date(endDate);
      // console.log(todayDate)
      // console.log(date1)
      // console.log(date2)
      if (todayDate.getTime() < date1.getTime()) {
        return "未生效";
      } else if (
        todayDate.getTime() < date2.getTime() &&
        todayDate.getTime() > date1.getTime()
      ) {
        return "生效中";
      } else if (todayDate.getTime() > date2.getTime()) {
        return "已失效";
      }
    },
  },
};
</script>
